import { render, staticRenderFns } from "./AssembleiaItemPautaList.vue?vue&type=template&id=92794ca2&"
import script from "./AssembleiaItemPautaList.vue?vue&type=script&lang=js&"
export * from "./AssembleiaItemPautaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports